export enum AdminActionTypes {
  SET_STATE = 'ADMIN.SET_STATE',

  GET_STATISTICS = 'ADMIN.GET_STATISTICS',
  GET_SETTINGS = 'ADMIN.GET_SETTINGS',
  UPDATE_SETTINGS = 'ADMIN.UPDATE_SETTINGS',
}
